import { observable, action, makeObservable, set } from 'mobx';

import { CashlessReceiptType } from '../../shared/support/modelTypes';

export interface CashlessReceiptFormStoreType {
	model: CashlessReceiptType;
	list: Array<any>;
	isLoading: boolean;
	isNew: boolean;
	isChanged: boolean;
	responseCode: number;
	responseHistoryCode: number;
	pluralName: string;
	collectedModels: Array<any>;
	filterInclude: Array<any>;
	selectedItems: Array<any>;
	requiredToFill: Array<{ predefinedName: string; property: string; relation: string }>;
	isFirstLoad: boolean;
	name: string;
	isSequenceNumberChangedManually: boolean;
	setValue(model: any, key: string, value: any): void;
}

class CashlessReceiptFormStore implements CashlessReceiptFormStoreType {
	constructor() {
		makeObservable(this, {
			model: observable,
			list: observable,
			isLoading: observable,
			isNew: observable,
			responseCode: observable,
			responseHistoryCode: observable,
			isChanged: observable,
			pluralName: observable,
			collectedModels: observable,
			filterInclude: observable,
			selectedItems: observable,
			requiredToFill: observable,
			isFirstLoad: observable,
			name: observable,
			isSequenceNumberChangedManually: observable,
			setValue: action
		});
	}

	model = {
		organizationId: null,
		organizationBankAccountId: null,
		amount: 0,
		partnerId: null,
		contractId: null,
		partnerBankAccountId: null,
		senderBankAccountId: null,
		cashBoxSenderId: null,
		incomeDocDate: new Date(),
		incomeDocNumber: '',
		paymentPurpose: null,
		note: null,
		accountablePersonId: null,
		postedByBank: false,
		postedAtBank: new Date(),
		bankPaymentId: null,
		posted: false,
		periodAt: null,
		responsibleId: null,
		deleted: false,
		authorId: null,
		ownerId: null,
		ownerType: null,
		documentBaseId: null,
		documentBaseType: null
	};
	list = [];
	isLoading = false;
	isNew = false;
	responseCode = 0;
	responseHistoryCode = 0;
	isChanged = false;
	isSequenceNumberChangedManually = false;
	pluralName = 'cashlessReceipts';
	filterInclude = ['partner', 'organization', 'contract', 'organizationBankAccount', 'partnerBankAccount', 'senderBankAccount', 'cashBoxSender', 'accountablePerson'];
	collectedModels = [] as Array<any>;
	selectedItems = [] as Array<any>;
	requiredToFill = [
		{
			predefinedName: 'DefaultOrganization',
			property: 'organizationId',
			relation: 'organization'
		}
	];
	isFirstLoad = true;
	name = 'OrmCashlessReceipt';
	setValue(model: any, key: string, value: any) {
		set(model, key, value);
	}
}

export const cashlessReceiptFormStore = new CashlessReceiptFormStore();

export default CashlessReceiptFormStore;
